var _style, _path, _polyline, _line, _line2, _line3, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBodyVitals(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#2F99F1;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.14,8.36l29.98,0.08c0,0,2.75-0.55,2.83,2.28s0,20.64,0,20.64s0.63,3.14-2.59,3.14c-3.22,0-30.3,0-30.3,0 s-2.75,0.55-2.67-3.14c0.08-3.69,0-20.64,0-20.64S7.55,8.2,10.14,8.36z"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "17.99,20.52 22.54,20.52 24.04,18.8 25.76,25.86 27.41,16.05 30.08,22.01 31.57,20.44 32.9,20.29 "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 36.02,
    y1: 24.13,
    x2: 36.08,
    y2: 28.61
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 34.02,
    y1: 25.78,
    x2: 34.08,
    y2: 28.55
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 31.96,
    y1: 27.13,
    x2: 32.02,
    y2: 28.61
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.32,34.49l0.06,2.3c0,0,0.29,1.18-1.65,1.3c-1.94,0.12-20.72,0-20.72,0s-1.53,0.18-1.53-1.53c0-1.71,0-2,0-2 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.41,38.18l0.08,4.63c0,0,0.31,1.57-1.73,1.41c-2.04-0.16-2.28,0.04-2.33-1.9s-0.12-4.18-0.12-4.18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.95,12.54h20.78c0,0,2.83-0.35,2.83,2.41S38.5,26.66,38.5,26.66s0.59,3.12-2.3,3.06 c-2.88-0.06-20.96,0-20.96,0s-2.88,0.06-2.94-2.71c-0.06-2.77-0.06-12.3-0.06-12.3S12.42,12.3,14.95,12.54z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBodyVitals);
export default __webpack_public_path__ + "static/media/body-vitals.94f252028d84d0cc989bdaaf75374a3f.svg";
export { ForwardRef as ReactComponent };